import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { SettingsService } from '../shared/api/resources/settings/settings.service';
import {AgentService} from '../shared/api/resources/agent/agent.service';
import {UserService} from '../shared/api/resources/user/user.service';
import {ProtocolService} from '../shared/global/protocol.service';

@Component({
  selector: 'app-experiences',
  templateUrl: './experiences.component.html',
  styleUrls: ['./experiences.component.scss']
})
export class ExperiencesComponent implements OnInit, OnDestroy {
  private _originalPartners: any[];
  private _partners: any[];
  private protocoleServiceSubscription: any;
  partnersWithLocation: any[];
  partnersLoading = false;


  constructor(
    private _router: Router,
    private _settings: SettingsService,
    private _userService: UserService,
    private _agentService: AgentService,
    private _protocolService: ProtocolService) { }

  async ngOnInit() {
    this.protocoleServiceSubscription = this._protocolService.protocolAccepted.subscribe(() => this.getResume(true));
    await this.getResume();
  }

  ngOnDestroy() {
    if (!!this.protocoleServiceSubscription) {
      this.protocoleServiceSubscription.unsubscribe();
    }
  }

  async getResume(force = false) {
    this.partnersLoading = true;
    this._originalPartners = [];
    this._partners = [];
    this.partnersWithLocation = [];
    try {
      const suppliers = await this._agentService.updateSuppliers(force);
      for (const partner of suppliers) {
        this._originalPartners.push(partner.supplier);
        this._partners.push(partner);
        if (partner.supplier.settingsPresets
          && partner.supplier.settingsPresets.location
          && partner.supplier.settingsPresets.location.latitude !== null
          && partner.supplier.settingsPresets.location.longitude !== null) {
          this.partnersWithLocation.push(partner);
        }
      }
    } finally {
      this.partnersLoading = false;
    }
  }

  goToPartner(partner: any) {
    if (partner.supplier.protocolStatus !== 5) {
      this._router.navigateByUrl('partner/' + partner.supplier.id);
    }
  }

  parseFloat(value: string): number {
    return parseFloat(value);
  }

  get userName(): string {
    return this._userService.user ? this._userService.user.name : '';
  }

  get partners(): any[] {
    return this._partners;
  }

  set partners(value: any[]) {
    this._partners = value;
  }

  get url() {
    return this._router.url;
  }

}



// WEBPACK FOOTER //
// ./src/app/experiences/experiences.component.ts